import { Component, OnInit, Inject } from '@angular/core';
import { SharedService } from '../../../shared/shared.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { AbstractControl } from '@angular/forms';
import { LoggerService } from '../../../logger/logger.service';
import { AgentService } from '../../agent.service';
import { MatDialog, MatProgressSpinnerModule, MatSlideToggleModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormsModule, FormControl, FormBuilder, Validators, ReactiveFormsModule} from '@angular/forms';

@Component({
    selector: 'app-agent-dashboard',
    templateUrl: './billing-sync-component.html',
    styleUrls: ['./billing-sync-component.css']
  })

  export class BillingSyncComponent implements OnInit {

    public search_key : any;
    public disable_button : boolean;
    public showErrorMessage : boolean;
    public showMessage : boolean;  
    public requestObject : Object;
    public message : string[];
    public errorMessage : string;  
    public send_email : boolean;
    public send_text: boolean;
    private screen: string = 'billing_sync';

    constructor(private activatedRoute: ActivatedRoute,
        private sharedService: SharedService, private dialog: MatDialog,private logger:LoggerService, private router: Router,
        private localStorageService: LocalStorageService, private agentService: AgentService) {
          this.disable_button = true;
          this.sharedService.setHeaderTitle(this.screen); 
          this.sharedService.IsTheSessionValid(this.screen, true);
          this.send_email = false;
          this.send_text = false;                      
       }
      
    ngOnInit(){}

    sync(){
      this.showErrorMessage = false;
      this.showMessage = false;
      this.sharedService.setLoader(this.screen, true);
      
      this.requestObject = {
        'token': this.localStorageService.get('agentToken'),
        'search_key': this.search_key,  
        'send_text': this.send_text,
        'send_email': this.send_email        
      } 
      this.sharedService.syncAccount(this.requestObject)
      .then(response => {
        this.message = response.messages;       
        this.showMessage = true;
        this.sharedService.setLoader(this.screen, false);

      }).catch((ex)=>{       
        this.errorMessage = ex._body;
        this.showErrorMessage = true;   
        this.sharedService.setLoader(this.screen, false);
      });
    }   

    validate(e : Event){
      this.disable_button = false;
      if (this.search_key.length == undefined || this.search_key.length == 0){
        this.disable_button = true;
      }         
    }  
  }



// WEBPACK FOOTER //
// ./src/app/agent/agent-dashboard/billing-sync/billing-sync-component.ts